import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import Cookies from 'js-cookie';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { map } from 'rxjs/operators';
import { MessageService } from './message.service';
import { OlapService } from './olap-service.service';
import { ILoan } from '../interfaces/loan';
import { IgetLoan } from "app/interfaces/getloans";
import { Relationship } from "app/interfaces/relationships";


@Injectable()
export class LoanService {

    Loan: Loan = new Loan();

    constructor(private http: HttpClient,
                private router: Router,
                private messageService: MessageService,
                private olapService: OlapService) {}

    httpHeaders(): any {
        let headers = {
            withCredentials: false,
            headers: null
        };
        if (Cookies.get('csrftoken')) {
            headers = {
                withCredentials: true,
                headers: new HttpHeaders({
                    'X-CSRFToken': Cookies.get('csrftoken')
                })
            };
        }
        return headers;
    }

    checkNotAllowedForNewLoan(): any {
        const httpOptions = {
            withCredentials: true,
            headers: new HttpHeaders({
                'X-CSRFToken': Cookies.get('csrftoken')
            })
        };
        return this.http.get(environment.apiUrl + 'client/?action=is_allowed_for_new_loan', httpOptions)
            .subscribe((resp: any) => {
                    console.log('gotoApply -> checkNotAllowedForNewLoan', resp)
                    if (resp.status === 'success') {
                        this.router.navigateByUrl('/olap_apply#new');
                        return;
                    }
                    this.router.navigateByUrl('/olap_loans');
                }, (resp: any) => {
                    if (resp.error) {
                        if (resp.error.status === 'failed') {
                            alert(resp.error.message);
                            this.router.navigateByUrl('/olap_loans');
                            return;
                        }
                    }
                });
    }

    changeState(state, client_id, loan_id): Observable<any> {
        let httpOptions = {
            withCredentials: false,
            headers: null
        };
        if (Cookies.get('csrftoken')) {
            httpOptions = {
                withCredentials: true,
                headers: new HttpHeaders({
                    'X-CSRFToken': Cookies.get('csrftoken')
                })
            };
        }
        return this.http.put(environment.apiUrl + 'loan/' + loan_id,
                {
                    state: state,
                    loan_id: loan_id,
                    client_id: client_id
                }, httpOptions);
    }

    declined(data: any): Observable<any> | any {
        if (!data.id) {
            throw 'Exception: loan_id is empty or null!';
        }
        return this.http.put(environment.apiUrl + 'loan/' + data.id, data, this.httpHeaders()).map(resp => resp);
    }

    updateLoanDataBy(loan_id: any, data: object): Observable<any> {
        return this.http.put(environment.apiUrl + 'update_loan_by_data/' + loan_id, data, this.httpHeaders())
                    .map(resp => resp );
    }

    getAccreditedBanks(): Observable<any> {
        let httpHeaders = {
            withCredentials: false,
            headers: null
        };
        if (Cookies.get('csrftoken')) {
            httpHeaders = {
                withCredentials: true,
                headers: new HttpHeaders({
                    'X-CSRFToken': Cookies.get('csrftoken')
                })
            }
        }
        return this.http.get(environment.apiUrl + 'accredited_banks/', httpHeaders)
            .map(resp => resp);
    }

    getEWallets(): Observable<any> {
        let httpHeaders = {
            withCredentials: false,
            headers: null
        };
        if (Cookies.get('csrftoken')) {
            httpHeaders = {
                withCredentials: true,
                headers: new HttpHeaders({
                    'X-CSRFToken': Cookies.get('csrftoken')
                })
            }
        }
        return this.http.get(environment.apiUrl + 'ewallets/', httpHeaders)
            .map(resp => resp);
    }

    getRenewalData(): Observable<any> {
        let httpHeaders = {
            withCredentials: false,
            headers: null
        };
        if (Cookies.get('csrftoken')) {
            httpHeaders = {
                withCredentials: true,
                headers: new HttpHeaders({
                    'X-CSRFToken': Cookies.get('csrftoken')
                })
            }
        }
        return this.http.get(environment.apiUrl + 'renewal_data/', httpHeaders)
            .map(resp => resp);
    }

    batchAutoDisburse(data: object): Observable<any> {
        return this.http.post(environment.apiUrl + 'disbursement/insta_credit_batch_release/', data, this.httpHeaders());
    }

    private handleError<T> (operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.log(`${operation} failed: ${error.message}`);
            return of(result as T);
        };
    }

    private log(message: string) {
        this.messageService.add('LoanService: ' + message);
    }

    getLoans(params: IgetLoan) : Observable<any> {

        const csrftoken: any = Cookies.get('csrftoken') ? Cookies.get('csrftoken') : null;

        let options = {
            withCredentials: true,
            headers: new HttpHeaders({
                'X-CSRFToken': csrftoken
            }),
            params: {
                recs_per_page: params.recs_per_page ? params.recs_per_page.toString() : '',
                current_page: params.current_page ? params.current_page.toString() : '',
                sort_field: params.sort_field ? params.sort_field : '',
                sort_order: params.sort_order ? params.sort_order : '',
                search_filter: params.search_filter ? JSON.stringify(params.search_filter) : ''
            }
        };

        return this.http.get<ILoan[]>(environment.apiUrl + 'loan/', options)
            .pipe(
                map((values) => {
                    let raw_loans: ILoan[] = <any>values['data'];
                    let loans: ILoan[] = [];

                    if (raw_loans.length) {
                        for (const loan of raw_loans) {
                            let loan_obj: ILoan = loan;

                            loan_obj['id'] = loan.id;
                            loan_obj['amt_applied'] = 'Php ' + this.olapService.formatter(loan.amt_applied, 'currency');
                            loan_obj['loan_term'] = parseInt(loan.loan_term).toFixed(0) + ' month(s)';
                            loan_obj['amt_approved'] = loan.amt_approved == null ? 'not yet available' : 'up to Php ' + this.olapService.formatter(loan.amt_approved, 'currency');
                            loan_obj['state'] = loan.state;
                            loan_obj['date_submission'] = loan.date_submission ? (<string>loan.date_submission.split('.')[0]).replace('T', ' ') : '';
                            if (Cookies.get('isStaff') || (Cookies.get('OLAP_UserGroup') && Cookies.get('OLAP_UserGroup').includes('olap_hr_clients'))) {
                                loan_obj['name'] = loan.lastname + ', ' + loan.firstname;
                                loan_obj['company_name'] = loan.company_name;
                            } else { loan_obj['name'] == null; }
                            loan_obj['disbursement_type'] = loan.disbursement_type ? loan.disbursement_type : 'NA';
                            loan_obj['exp_accept_release'] = loan.exp_accept_release ? loan.exp_accept_release : 'Not yet available';
                            loan_obj['erp_encoded'] = loan.erp_encoded;
                            if(loan.state == 'RELEASED'){
                                loan_obj['renewal_button'] = true;
                                loan_obj['renewal_button_text'] = 'Renew';
                            }else if(loan.state == 'DECLINED'){
                                loan_obj['renewal_button'] = true;
                                loan_obj['renewal_button_text'] = 'Resubmit';
                            }else{
                                loan_obj['renewal_button'] = false;
                                loan_obj['renewal_button_text'] = 'NA';
                            }
                            loans.push(loan_obj);
                        }
                    }

                    return {
                        data: loans,
                        total_recs: values['total_recs'],
                        recs_per_page: values['recs_per_page'],
                        current_page: values['current_page'],
                        total_recs_in_current_page: values['total_recs_in_current_page']
                    };
                })
            ).catch((error: HttpErrorResponse) => {
                return Observable.throw(error || 'Server Error');
            });
    }

    searchCompany(searchTerm: string): Observable<any> {
        let httpHeaders = {
            withCredentials: false,
            headers: null
        };
        return this.http.get(environment.apiUrl + 'company/?search_term='+searchTerm, httpHeaders)
            .map(resp => resp);
    }

    getRelationshipOptions(): Observable<Relationship[]> {
      const url = `${environment.apiUrl}client/relationships/`;
      return this.http.get<Relationship[]>(url);
    }

}

class Loan {
    constructor(
        public state: string = '',
    ) {}
}



// WEBPACK FOOTER //
// /opt/tglfc/olap/salary_web/src/app/service/loan.service.ts